<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Procedimentos</th>
          <th>Situações</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tabela in tabelas" :key="tabela._id">
          <td>{{ tabela.nome }}</td>
          <td>
            <button
              data-test-id="button-exibiralertavalores-1"
              class="btn btn-xs btn-link"
              @click="
                exibirAlertaValores(
                  'Procedimentos',
                  tabela.procedimentos,
                  ['codigo', 'nome'],
                  ['Código', 'Nome']
                )
              "
            >
              Ver procedimentos
            </button>
          </td>
          <td>{{ tabela.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-2"
              :to="'/tabelasProcedimento/cadastro/' + tabela._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'

export default {
  name: 'TabelasProcedimentoTabela',
  mixins: [alertaMixin],
  props: {
    tabelas: {
      type: Array,
      required: true,
    },
  },
}
</script>
